<template>
  <div>
    <va-modal
      :title="titre"
      class="modal"
      v-model="showCreationAdt"
      okText="Créer"
      cancelText="Annuler"
      v-on:ok="saveAdt"
      v-on:cancel="closeModal"
    >
      <div class="row row-inside">
        <div class="flex md12">
          <va-input
            v-model="year"
            placeholder="-"
            label="Année"
            :error="!validYear"
          />
        </div>
      </div>
      <div class="row row-inside">
        <div class="flex md12">
          <va-input
            v-model="amount"
            placeholder="-"
            label="Montant"
            :error="!validAmount"
          />
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["idsyndicat", "showEditor"],
  data() {
    return {
      showCreationAdt: false,
      amount: null,
      year: null,
    };
  },
  methods: {
    async saveAdt() {
      try {
        this.showCreationAdt = true;
        if (!this.year) {
          this.launchEpicmaxToast("L'année doit être renseignée");
          return;
        }
        if (!this.amount) {
          this.launchEpicmaxToast(
            "Le montant de la cotisation doit être renseigné"
          );
          return;
        }
        if (!this.validYear) {
          this.launchEpicmaxToast("Année invalide");
          return;
        }
        if (!this.validAmount) {
          this.launchEpicmaxToast("Montant invalide");
          return;
        }

        // send the demand to the backend
        let idorg;
        if (this.idsyndicat === "opam") {
          idorg = 2;
        } else if (this.idsyndicat === "agromer") {
          idorg = 3;
        } else if (this.idsyndicat === "scapp") {
          idorg = 1;
        } else if (this.idsyndicat === "Languedoc-Roussillon") {
          idorg = 6;
        } else if (this.idsyndicat === "Vendee") {
          idorg = 4;
        } else if (this.idsyndicat === "SDEP") {
          idorg = 7;
        } else {
          console.log("no organisation selected");
          this.launchEpicmaxToast("Erreur veuillez rafraichir la page");
          return;
        }
        let params = {
          year: this.year,
          amount: this.amount,
          idorg: idorg,
        };

        await axios.post("/api/adt/adhesion", params);
        this.$emit("updateList");
        this.closeModal();
        this.launchEpicmaxToast("Adhésion créée");
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la création");
        console.log(error);
        if (error.response) {
          console.log(error.response);
        }
      }
    },
    closeModal() {
      this.$emit("close");
      this.showCreationAdt = false;
      this.amount = null;
      this.year = null;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
    isNormalInteger(str) {
      var n = Math.floor(Number(str));
      return n !== Infinity && String(n) === str && n >= 0;
    },
  },
  computed: {
    validYear: function () {
      if (
        (this.isNormalInteger(this.year) && this.year.length === 4) ||
        this.year === null
      ) {
        return true;
      }
      return false;
    },
    validAmount: function () {
      if (this.isNormalInteger(this.amount) || this.amount === null) {
        return true;
      }
      return false;
    },
    titre: function () {
      let text = "Création nouvel appel à cotisation: ";

      if (this.idsyndicat === "opam") {
        text = text + "OPAM-B";
      } else if (this.idsyndicat === "agromer") {
        text = text + "AGROMER";
      } else if (this.idsyndicat === "scapp") {
        text = text + "SCAPP";
      } else if (this.idsyndicat === "Languedoc-Roussillon") {
        text = text + "Languedoc-Roussillon";
      } else if (this.idsyndicat === "Vendee") {
        text = text + "Vendée";
      } else if (this.idsyndicat === "SDEP") {
        text = text + "S.D.E.P.";
      } else {
        text = "";
      }
      return text;
    },
  },
  watch: {
    showEditor(newvalue) {
      if (newvalue === true) {
        this.showCreationAdt = true;
      }
    },
  },
};
</script>

<style>
</style>
